export default {
      id: "remove-icon-usage",
      viewBox: "0 -960 960 960",
      url: __webpack_public_path__ + "icons.svg#remove-icon",
      toString: function () {
        return this.url;
      }
    }